import {ScannerForm} from "../../features/Form";

const MainPage = () => {

    const goToForm = () => {
        const section = document.querySelector( '#form' );
        section?.scrollIntoView( { behavior: 'smooth', block: 'start' } );
    };

    return (
        <main>
            <div className="blured_bg">
                <section id="section_1">
                    <div className="offer_wrapper">
                        <div className="offer">Выгодная карта для закупа товаров</div>
                        <div className="descriptor">Кешбэк 2% и удобные условия для байеров</div>
                    </div>
                    <div className="cart_image_wrapper">
                        <div className="cart_image">
                            <img src="../assets/new-img/mastercard-1.1.png" className="card_top" alt="card"/>
                            <img src="../assets/new-img/mastercard-2-1.png" className="card_bottom" alt="card"/>
                        </div>
                    </div>
                    <div className="benefits">
                        <div className="one_benefit">
                            <div className="one_benefit_icon">
                                <img src="../assets/img/pc.svg"/>
                            </div>
                            <div className="one_benefit_title">
                                Оформите заявку онлайн
                            </div>
                        </div>
                        <div className="one_benefit">
                            <div className="one_benefit_icon">
                                <img src="../assets/img/credit-card%201.svg"/>
                            </div>
                            <div className="one_benefit_title">
                                Получите карту бесплатно
                            </div>
                        </div>
                        <div className="one_benefit">
                            <div className="one_benefit_icon">
                                <img src="../assets/img/pin.svg"/>
                            </div>
                            <div className="one_benefit_title">
                                Доставим бесплатно в любую точку Бишкека и города Ош
                            </div>
                        </div>
                    </div>
                    <button className="blue_btn" data-aos="fade-up" onClick={() => goToForm()}>Оформить карту</button>
                </section>
                <section id="section_2">
                    <div className="title" data-aos="fade-up">Закупаетесь на китайских или американских маркетплейсах?</div>
                    <div className="description" data-aos="fade-up">
                        Mastercard World от ККБ– бесплатная карта, созданная специально для онлайн-покупок. Оформите карту Mastercard с кэшбэком 2% на международные покупки и получайте выгоду с каждого закупа!
                    </div>
                    <div className="banners">
                        <div className="banner">
                            <div className="banner-text">
                                <div className="banner-text_title">Кэшбэк 2%</div>
                                <div className="banner-text_description">
                                    Мы начислим Вам кэшбэк на карту реальными деньгами в размере 2% от суммы любой покупки на международных платформах.
                                </div>
                            </div>
                        </div>

                        <div className="banner">
                            <div className="banner-text">
                                <div className="banner-text_title">Бесплатное пополнение</div>
                                <div className="banner-text_description">
                                    Пополняйте карту без комиссии в любых платёжных терминалах по Кыргызстану и переводом по QR-коду с любых карт банков Кыргызстана.
                                </div>
                            </div>
                        </div>


                        <div className="banner">
                            <div className="banner-text">
                                <div className="banner-text_title">Удобная оплата за границей</div>
                                <div className="banner-text_description">
                                    Оплата в юанях и долларах с автоматической конвертацией по выгодному курсу.
                                </div>
                            </div>
                        </div>


                        <div className="banner">
                            <div className="banner-text">
                                <div className="banner-text_title">Бесплатно</div>
                                <div className="banner-text_description">
                                    Меньше лишних трат – больше выгоды! Мы не берём деньги за выпуск карты и за все пять лет обслуживания.
                                </div>
                            </div>
                        </div>


                        <div className="banner">
                            <div className="banner-text">
                                <div className="banner-text_title">Онлайн</div>
                                <div className="banner-text_description">
                                    Всё для Вашего удобства: карту Mastercard World можно оформить онлайн. Это удобно и быстро. Мы бесплатно доставим Вашу карту в любую точку Бишкека и города Ош.
                                </div>
                            </div>
                        </div>

                    </div>
                </section>
            </div>
            <div className="s3_wrapper">
                <section id="section_3">
                    <div className="form_header" id="form">
                        <div className="form_header_title" data-aos="fade-up">Оформите бесплатную карту онлайн прямо
                            сейчас!
                        </div>
                        <div className="form_header_description" data-aos="fade-up">Доставка в любую точку Бишкека и
                            города Ош
                        </div>
                    </div>
                    <div className="form_wrapper">
                        <ScannerForm/>
                        <div className="image_wrapper">
                            <img src="../assets/img/illustration.svg"/>
                        </div>
                    </div>
                </section>
            </div>
            <div className="s4_wrapper">
                <section id="section_4">
                    <div className="info">
                        <div className="title"
                             data-aos-easing="ease-in-back"
                             data-aos-delay="200"
                             data-aos-offset="0"
                             data-aos="fade-zoom-in"
                        >
                            Мобильный банкинг без границ.
                        </div>
                        <ul className="points"
                            data-aos-easing="ease-in-back"
                            data-aos-delay="200"
                            data-aos-offset="0"
                            data-aos="fade-zoom-in"
                        >
                            <li>Оплачивайте услуги без
                                комиссий, совершайте переводы с карты на карту любых банков – и всё это в одном
                                приложении.
                                Теперь деньги работают быстро, онлайн и на вас.
                            </li>
                            <li>1. Бесплатно скачайте приложение KKB в App Store или Google Play</li>
                            <li>2. Зарегистрируйтесь по номеру телефона</li>
                            <li>3. Пользуйтесь услугами банка когда и где вам удобно</li>
                        </ul>
                        <div className="app_links">
                            <a data-aos="fade-right"
                               data-aos-delay="500"
                               href="https://apps.apple.com/kg/app/kkb/id1522841048"
                               target="_blank">
                                <img src="../assets/img/app_store.svg"/>
                            </a>
                            <a data-aos="fade-right"
                               data-aos-delay="200"
                               href="https://play.google.com/store/apps/details?id=kg.kkb.app"
                               target="_blank">
                                <img src="../assets/img/play_market.svg"/>
                            </a>
                        </div>
                    </div>
                </section>
                <img className="phones" src="../assets/img/phones-mobile.png"/>
            </div>
            <div className="s5_wrapper">
                <section id="section_5">
                    <div className="title">Тарифы и документы</div>
                    <div className="docs">
                        <div className="doc" data-aos="fade-right" data-aos-delay="600">
                            <div className="doc_title">Тарифы</div>
                            <div className="doc_text">Все цены и тарифы</div>
                            <div className="doc_controls">
                                <a className="doc_button" href="MasterCard World.pdf" target="_blank">
                                    <img src="../assets/img/Play.svg"/>
                                </a>
                                <div className="doc_icon">
                                    <img src="../assets/img/coins.svg"/>
                                </div>
                            </div>
                        </div>

                        <div className="doc" data-aos="fade-right" data-aos-delay="400">
                            <div className="doc_title">Договор оферты</div>
                            <div className="doc_text">Договор с банком</div>
                            <div className="doc_controls">
                                <a className="doc_button" href="dogovor-pub-oferty2025-rus-owg.pdf" target="_blank">
                                    <img src="../assets/img/Play.svg"/>
                                </a>
                                <div className="doc_icon">
                                    <img src="../assets/img/briefcase.svg"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </main>
    );
}

export default MainPage;
